import { Switch } from 'react-router-dom'
import { DESIGN_PATH, DOC_PATH, FOLDER_DOC_PATH, FOLDER_VIEWS_PATH } from 'paths'
import { SentryRoute } from 'components/SentryRoute'
import { Sidebar } from './Sidebar'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const WorkspaceDashboardSidebar = () => {
  const { isMobile } = useResponsiveDesign()

  return (
    <Switch>
      <SentryRoute path={FOLDER_VIEWS_PATH}>
        <Sidebar isLockable={false} />
      </SentryRoute>
      <SentryRoute path={[DOC_PATH, FOLDER_DOC_PATH, DESIGN_PATH]}>
        <Sidebar floating={!isMobile} />
      </SentryRoute>
      <SentryRoute path="/">
        <Sidebar isLockable={false} />
      </SentryRoute>
    </Switch>
  )
}
